/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs */

const en_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complex animation, scroll narrative, and interaction craft where the product is the experience.`)
};

const ar_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حركة معقدة وسرد بالتمرير وحرفية تفاعل حيث المنتج هو التجربة.`)
};

const bn_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জটিল অ্যানিমেশন, স্ক্রল ন্যারেটিভ ও ইন্টারঅ্যাকশন কারুকার্য, যেখানে পণ্যই অভিজ্ঞতা।`)
};

const de_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplexe Animation, Scroll-Erzählung und Interaktionskunst, bei der das Produkt das Erlebnis ist.`)
};

const es_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animación compleja, narrativa de desplazamiento y artesanía de interacción donde el producto es la experiencia.`)
};

const fr_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animation complexe, récit de défilement et artisanat d'interaction où le produit est l'expérience.`)
};

const pt_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animação complexa, narrativa de rolagem e interação artesanal onde o produto é a experiência.`)
};

const zh_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复杂的动画、滚动叙事和交互手艺，产品本身就是体验。`)
};

const tr_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürünün deneyim olduğu karmaşık animasyon, kaydırmalı anlatım ve etkileşim sanatı.`)
};

const ru_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сложная анимация, повествование с прокруткой и интерактивное искусство, где продукт, это опыт.`)
};

const pl_svc_full_stack_web_apps_motion_desc6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Złożona animacja, przewijana narracja i interakcja, gdzie produktem jest doświadczenie.`)
};

/**
* | output |
* | --- |
* | "Complex animation, scroll narrative, and interaction craft where the product is the experience." |
*
* @param {Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_motion_desc6 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Motion_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_motion_desc6(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_motion_desc6(inputs)
	return en_svc_full_stack_web_apps_motion_desc6(inputs)
});
export { svc_full_stack_web_apps_motion_desc6 as "svc_full-stack-web-apps_MOTION_desc" }